define("shared/components/shared/profile-categorization/rewards-steps/report", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::ProfileCategorization::CategorizeSteps::ProgressBar @progressValue={{1}} @socialProfile={{@socialProfile}} />
  
  {{#let (concat "profile_categorization.reports." @sectionName ".") as |prefix|}}
    {{#if (or @forceHideReports (not this.isInstagramProfile))}}
      <div {{did-insert (fn @setReportState true)}}>
        <Shared::ProfileCategorization::RewardsSteps::Report::None
          @clearSelectedCategory={{this.clearSelectedCategory}}
          @exitCategorization={{@exitCategorization}}
          @isModalFlow={{this.isModalFlow}}
          @prefix={{prefix}}
          @socialProfile={{@socialProfile}}
        />
      </div>
    {{else if this.showPartnershipsOptIn}}
      <div {{did-insert (fn @setReportState true)}} {{track "viewed-creator-optin-self-cat"}}>
        <Shared::ProfileCategorization::RewardsSteps::PartnershipsOptIn
          @clearSelectedCategory={{this.clearSelectedCategory}}
          @exitCategorization={{@exitCategorization}}
          @goToPartnerships={{this.goToPartnerships}}
          @prefix={{prefix}}
          @socialProfile={{@socialProfile}}
        />
      </div>
    {{else}}
      <Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData
        @socialProfile={{@socialProfile}}
        as |profileReportData|
      >
        <Shared::ProfileCategorization::RewardsSteps::ProvideIndustryReportData
          @averageProfileEngagement={{profileReportData.averageProfileEngagement}}
          @socialProfile={{@socialProfile}}
          as |industryReportData|
        >
          {{#if (or profileReportData.isLoading industryReportData.isLoading)}}
            <Shared::ProfileCategorization::Loading />
          {{else if (and profileReportData.hasEnoughPosts industryReportData.isIndustryDataPresent)}}
            <div {{did-insert (fn @setReportState false)}}>
              {{#if this.showReportsStep}}
                <Shared::ProfileCategorization::RewardsSteps::Report::Full
                  @changeTabNum={{this.changeTabNum}}
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @currentTabNum={{this.currentTabNum}}
                  @exitCategorization={{@exitCategorization}}
                  @industryReportData={{industryReportData}}
                  @isModalFlow={{this.isModalFlow}}
                  @prefix={{prefix}}
                  @profileReportData={{profileReportData}}
                  @sectionName={{@sectionName}}
                  @socialProfile={{@socialProfile}}
                />
              {{else}}
                <Shared::ProfileCategorization::RewardsSteps::Report::GoToFull
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @exitCategorization={{@exitCategorization}}
                  @isAnalyticsFlow={{this.isAnalyticsFlow}}
                  @prefix={{prefix}}
                  @socialProfile={{@socialProfile}}
                  @toggleShowReportsStep={{set this "showReportsStep" true}}
                  @trackSkipRewards={{this.trackSkipRewards}}
                />
              {{/if}}
            </div>
          {{else if industryReportData.isIndustryDataPresent}}
            <div {{did-insert (fn @setReportState false)}}>
              {{#if this.showReportsStep}}
                <Shared::ProfileCategorization::RewardsSteps::Report::Partial
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @exitCategorization={{@exitCategorization}}
                  @industryReportData={{industryReportData}}
                  @isModalFlow={{this.isModalFlow}}
                  @prefix={{prefix}}
                  @sectionName={{@sectionName}}
                  @socialProfile={{@socialProfile}}
                />
              {{else}}
                <Shared::ProfileCategorization::RewardsSteps::Report::GoToPartial
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @exitCategorization={{@exitCategorization}}
                  @isAnalyticsFlow={{this.isAnalyticsFlow}}
                  @prefix={{prefix}}
                  @socialProfile={{@socialProfile}}
                  @toggleShowReportsStep={{set this "showReportsStep" true}}
                  @trackSkipRewards={{this.trackSkipRewards}}
                />
              {{/if}}
            </div>
          {{else}}
            <div {{did-insert (fn @setReportState true)}}>
              <Shared::ProfileCategorization::RewardsSteps::Report::NotAvailable
                @clearSelectedCategory={{this.clearSelectedCategory}}
                @exitCategorization={{@exitCategorization}}
                @isModalFlow={{this.isModalFlow}}
                @prefix={{prefix}}
                @socialProfile={{@socialProfile}}
              />
            </div>
          {{/if}}
        </Shared::ProfileCategorization::RewardsSteps::ProvideIndustryReportData>
      </Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData>
    {{/if}}
  {{/let}}
  */
  {
    "id": "hGjpO2kL",
    "block": "[[[8,[39,0],null,[[\"@progressValue\",\"@socialProfile\"],[1,[30,1]]],null],[1,\"\\n\\n\"],[44,[[28,[37,2],[\"profile_categorization.reports.\",[30,2],\".\"],null]],[[[41,[28,[37,4],[[30,4],[28,[37,5],[[30,0,[\"isInstagramProfile\"]]],null]],null],[[[1,\"    \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[12],[1,\"\\n      \"],[8,[39,8],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@isModalFlow\",\"@prefix\",\"@socialProfile\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"isModalFlow\"]],[30,3],[30,1]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showPartnershipsOptIn\"]],[[[1,\"    \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[4,[38,9],[\"viewed-creator-optin-self-cat\"],null],[12],[1,\"\\n      \"],[8,[39,10],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@goToPartnerships\",\"@prefix\",\"@socialProfile\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"goToPartnerships\"]],[30,3],[30,1]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,11],null,[[\"@socialProfile\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,12],null,[[\"@averageProfileEngagement\",\"@socialProfile\"],[[30,7,[\"averageProfileEngagement\"]],[30,1]]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,4],[[30,7,[\"isLoading\"]],[30,8,[\"isLoading\"]]],null],[[[1,\"          \"],[8,[39,13],null,null,null],[1,\"\\n\"]],[]],[[[41,[28,[37,14],[[30,7,[\"hasEnoughPosts\"]],[30,8,[\"isIndustryDataPresent\"]]],null],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],false],null]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showReportsStep\"]],[[[1,\"              \"],[8,[39,15],null,[[\"@changeTabNum\",\"@clearSelectedCategory\",\"@currentTabNum\",\"@exitCategorization\",\"@industryReportData\",\"@isModalFlow\",\"@prefix\",\"@profileReportData\",\"@sectionName\",\"@socialProfile\"],[[30,0,[\"changeTabNum\"]],[30,0,[\"clearSelectedCategory\"]],[30,0,[\"currentTabNum\"]],[30,6],[30,8],[30,0,[\"isModalFlow\"]],[30,3],[30,7],[30,2],[30,1]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,16],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@isAnalyticsFlow\",\"@prefix\",\"@socialProfile\",\"@toggleShowReportsStep\",\"@trackSkipRewards\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"isAnalyticsFlow\"]],[30,3],[30,1],[28,[37,17],[[30,0],\"showReportsStep\",true],null],[30,0,[\"trackSkipRewards\"]]]],null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,8,[\"isIndustryDataPresent\"]],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],false],null]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showReportsStep\"]],[[[1,\"              \"],[8,[39,18],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@industryReportData\",\"@isModalFlow\",\"@prefix\",\"@sectionName\",\"@socialProfile\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,8],[30,0,[\"isModalFlow\"]],[30,3],[30,2],[30,1]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,19],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@isAnalyticsFlow\",\"@prefix\",\"@socialProfile\",\"@toggleShowReportsStep\",\"@trackSkipRewards\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"isAnalyticsFlow\"]],[30,3],[30,1],[28,[37,17],[[30,0],\"showReportsStep\",true],null],[30,0,[\"trackSkipRewards\"]]]],null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[12],[1,\"\\n            \"],[8,[39,20],null,[[\"@clearSelectedCategory\",\"@exitCategorization\",\"@isModalFlow\",\"@prefix\",\"@socialProfile\"],[[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"isModalFlow\"]],[30,3],[30,1]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]],[]]]],[]]],[1,\"      \"]],[8]]]]],[1,\"\\n    \"]],[7]]]]],[1,\"\\n  \"]],[]]]],[]]]],[3]]]],[\"@socialProfile\",\"@sectionName\",\"prefix\",\"@forceHideReports\",\"@setReportState\",\"@exitCategorization\",\"profileReportData\",\"industryReportData\"],false,[\"shared/profile-categorization/categorize-steps/progress-bar\",\"let\",\"concat\",\"if\",\"or\",\"not\",\"did-insert\",\"fn\",\"shared/profile-categorization/rewards-steps/report/none\",\"track\",\"shared/profile-categorization/rewards-steps/partnerships-opt-in\",\"shared/profile-categorization/rewards-steps/provide-profile-report-data\",\"shared/profile-categorization/rewards-steps/provide-industry-report-data\",\"shared/profile-categorization/loading\",\"and\",\"shared/profile-categorization/rewards-steps/report/full\",\"shared/profile-categorization/rewards-steps/report/go-to-full\",\"set\",\"shared/profile-categorization/rewards-steps/report/partial\",\"shared/profile-categorization/rewards-steps/report/go-to-partial\",\"shared/profile-categorization/rewards-steps/report/not-available\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report.hbs",
    "isStrictMode": false
  });
  let ReportComponent = _exports.default = (_dec = (0, _computed.equal)('args.socialProfile.type', 'InstagramProfile'), _dec2 = (0, _computed.equal)('args.sectionName', 'add_profile'), _dec3 = (0, _computed.equal)('args.sectionName', 'analytics'), _dec4 = (0, _computed.or)('isAddProfileFlow', 'isAnalyticsFlow'), (_class = class ReportComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "showReportsStep", _descriptor5, this);
      _initializerDefineProperty(this, "currentTabNum", _descriptor6, this);
      _initializerDefineProperty(this, "isInstagramProfile", _descriptor7, this);
      _initializerDefineProperty(this, "isAddProfileFlow", _descriptor8, this);
      _initializerDefineProperty(this, "isAnalyticsFlow", _descriptor9, this);
      _initializerDefineProperty(this, "isModalFlow", _descriptor10, this);
    }
    get showPartnershipsOptIn() {
      return this.args.sectionName === 'signup' && this.args.businessModel === 'blog_influencer' && (this.args.socialProfile.followedBy > 100 || this.args.socialProfile.followedBy === null) && this.args.socialProfile.isProfessional && this.auth.currentAccount.canInfluencerOptIn;
    }
    changeTabNum(tabNum) {
      this.currentTabNum = tabNum;
    }
    clearSelectedCategory(page) {
      this._trackRestartedCategorization(page);
      this.args.resetSelection();
    }
    goToPartnerships() {
      if (typeof this.args.exitCategorization === 'function') {
        this.args.exitCategorization(true);
      }
      const groupSlug = this.args.socialProfile.group.get('slug');
      this.router.transitionTo('cluster.partnerships.profile', groupSlug, this.args.socialProfile.socialIdentity.get('id'));
    }
    trackSkipRewards() {
      const {
        id,
        industry,
        businessModel,
        category,
        nickname
      } = this.args.socialProfile || {};
      this.segment.track('skipped-industry-comparison-self-cat', {
        profile: id,
        area: this.args.sectionName,
        bus_model: businessModel,
        industry,
        category,
        nickname
      });
    }
    _trackRestartedCategorization(page) {
      const eventName = 'redid-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;
      try {
        this.segment.track(eventName, {
          area: this.args.sectionName,
          user,
          profile: id,
          page,
          social_profile_nickname: nickname
        });
      } catch (error) {
        this.errors.handleAdapter(new Error(`Error Tracking ${eventName} from location ${this.args.sectionName}`), error);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showReportsStep", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentTabNum", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 2;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isInstagramProfile", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isAddProfileFlow", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isAnalyticsFlow", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isModalFlow", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "changeTabNum", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "changeTabNum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedCategory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPartnerships", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPartnerships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackSkipRewards", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackSkipRewards"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ReportComponent);
});